import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css'; // Import AOS animations
import './index.css'; // Custom CSS
import logoSrc from './img/logo.png';
import LazyLoad from 'react-lazyload'; // Import LazyLoad


function Home() {
  useEffect(() => {
    // Initialize AOS after critical content has loaded
    const timer = setTimeout(() => {
      AOS.init({
        duration: 800, // Reduce animation duration
        once: true, // Trigger animation only once
        mirror: false, // Prevent animations on scroll back
      });
    }, 500); // Add slight delay for better critical rendering

    return () => {
      clearTimeout(timer); // Clean up timer
      if (window.AOS) {
        window.AOS.refresh(); // Refresh AOS on component unmount
      }
    };
    
  }, []);
  

  return (
    <>
      {/* Preload Critical Assets */}
      <link rel="preload" href={logoSrc} as="image" />
      <link rel="preload" href="/fonts/Montserrat-Regular.woff2" as="font" type="font/woff2" crossOrigin="anonymous" />
<link rel="preload" href="/fonts/Montserrat-Bold.woff2" as="font" type="font/woff2" crossOrigin="anonymous" />


      {/* Banner Section */}
      <header className="banner-section">
        <div className="banner-logo">
          <LazyLoad height={100} offset={100} once>
            <img src={logoSrc} alt="Shigjeta Logo" loading="lazy" />
          </LazyLoad>
        </div>
        <div className="banner-container">
          <div className="banner-text">
            <h1 className="banner-title">fueling growth & innovation</h1>
            <p className="banner-description">
              The finest for a global impact—tailored solutions that drive success. We understand diverse markets and deliver strategies designed to meet your business needs, foster innovation, and create lasting growth.
            </p>
            <a href="/more-about-us" className="banner-button">Discover More</a>
          </div>
        </div>
      </header>

      {/* Video Section */}
      <section className="video-background">
        <LazyLoad height={400} offset={100} once placeholder={<div>Loading video...</div>}>
          <video
            className="video"
            src="/video/ARROW HOMEorABOUT.mp4"
            autoPlay
            muted
            loop
            playsInline
            preload="metadata" // Preload only metadata for faster rendering
            onError={(e) => console.error('Error loading video:', e)}
          />
        </LazyLoad>
      </section>

      {/* About Section */}

        <section className="about-headerParallax" data-aos="fade-up">
          <div className="about-header">
            <h1>Who We Are</h1>
            <p>
              At Shigjeta LLC, we are dedicated to driving innovation and delivering solutions that empower businesses. From our beginnings in Kaçanik, Kosovo, to global collaborations, our mission is to create real impact and real results. We believe in fostering youth talent, developing transformative products, and building meaningful partnerships for a greater world for all.
            </p>
          </div>
        </section>

      {/* About Content Section */}
      <section className="about-section">
        <div className="about-content">
          {/* First Row */}
          <div className="about-row" data-aos="fade-right">
            <div className="about-text" id="sec1">
              <h2>Our Vision and Mission</h2>
              <p>
                Our vision is to connect ideas, people, and technology to shape a better future. By investing in education, innovation, and sustainability, we aim to lead businesses toward growth and success. Our mission is clear: generate solutions that create measurable outcomes for our clients.
              </p>
            </div>
            <LazyLoad height={200} offset={100} once>
              <div className="about-image">
                <img src="img/pg1.1.png" alt="Vision and Mission" loading="lazy" />
              </div>
            </LazyLoad>
          </div>

          {/* Second Row */}
          <div className="about-row reverse" data-aos="fade-left">
            <div className="about-text">
              <h2>A Legacy of Success</h2>
              <ul>
                <li>1000+ Clients served across 80+ industries</li>
                <li>20+ Experts and 50+ Skilled Professionals in overall partnerships on our team</li>
                <li>5 MVP Products launched and ready for investment</li>
                <li>10+ Satisfied Partners globally</li>
              </ul>
            </div>
            <LazyLoad height={200} offset={100} once>
              <div className="about-image">
                <img src="img/pg1.2.png" alt="Our Achievements" loading="lazy" />
              </div>
            </LazyLoad>
          </div>

          {/* Third Row */}
          <div className="about-row" data-aos="fade-right">
            <div className="about-text">
              <h2>The People Behind Shigjeta</h2>
              <p>
                Our young team of software developers, designers, project managers, and industry leaders forms the backbone of Shigjeta. Together, we innovate, collaborate, and deliver solutions tailored to your needs. Even after 30 years, we’ll still be here because our team is made of 20-somethings—ensuring long-term partnerships.
              </p>
              <a href="/cv" className="banner-button">View Our Team</a>
            </div>
            <LazyLoad height={200} offset={100} once>
              <div className="about-image">
                <img src="img/pg1.3.png" alt="Meet Our Team" loading="lazy" />
              </div>
            </LazyLoad>
          </div>

          {/* Fourth Row */}
          <div className="about-row reverse" data-aos="fade-left">
            <div className="about-text">
              <h2>Where We Work</h2>
              <p>
                Headquartered in Kaçanik, Kosovo, our office is designed to inspire creativity and collaboration. With easy access from different municipalities, our workspaces, video studios, and brainstorming zones drive innovation.
              </p>
              <a href="/find-our-office" target="_blank" className="banner-button">Visit Our Office</a>
            </div>
            <LazyLoad height={200} offset={100} once>
              <div className="about-image">
                <img src="img/pg1.4.png" alt="Our Office" loading="lazy" />
              </div>
            </LazyLoad>
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;
